import { authenticationConstants as constants } from '../_constants/authentication.constants';

const initialState = {
  token: null,
  permissions: [],
  loggingIn: false,
  isAuthenticated: false,
  showAccountDomain: false
}

export function authentication(state = initialState, action) {
  if (action.type === constants.AUTH_SET_PERMISSIONS) {
    return {
      ...state,
      permissions: action.permissions
    }
  }

  if (action.type === constants.AUTH_SHOW_ACCOUNT_DOMAIN) {
    return {
      ...state,
      showAccountDomain: {
        accountData: action.accountData,
        authToken: action.authToken
      }
    }
  }

  if (action.type === constants.AUTH_LOGIN_SUCCESS) {
    return {
      ...state,
      loggingIn: false
    };
  }

  if (action.type === constants.AUTH_LOGIN_FAILURE) {
    return {
      ...state,
      token: null,
      loggingIn: false,
      isAuthenticated: false,
    };
  }

  if (action.type === constants.AUTH_SET_TOKEN) {
    return {
      ...state,
      token: action.token,
      isAuthenticated: true,
    }
  }

  if (action.type === constants.AUTH_LOGIN_REQUEST) {
    return {
      ...state,
      loggingIn: true
    };
  }

  return state;
}